module.exports = __webpack_public_path__ + "static/img/9.af915aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/9.png
// module id = a9FB
// module chunks = 0